module.exports = __webpack_public_path__ + "img/uy.uyd3a8689.svg";